import { initConfiguration } from '@sas/nova-core/config';

/**
 * Prevents nova-core from making calls to Viya
 */
export function initNovaCore() {
  initConfiguration({ disableConfigurationEndPoint: true });
  (window as any).sas.axiosPreventFetchAcceptLocale = true;
}
